import { useState, useEffect } from "react";
import { firestore } from "../firebase";
import DB_PATH from "../DB_PATH";
import moment from "moment";
import "moment/locale/es"; // Import Spanish locale

// Set moment to use Spanish locale
moment.locale("es");

const formatDate = (timestamp) => {
  if (!timestamp) return "";
  // Check if it's a Firebase Timestamp
  const date = timestamp.toDate ? timestamp.toDate() : timestamp;
  return moment(date).format("DD/MM/YY hh:mm");
};

const useUserQuestions = ({ userId }) => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserQuestions = async () => {
      if (!userId) {
        setError("User ID is required");
        setLoading(false);
        return;
      }

      try {
        const questionsSnapshot = await firestore
          .collection(DB_PATH.QUESTION)
          .where("userId", "==", userId)
          .get();

        const userQuestions = questionsSnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data,
            createdAt: formatDate(data.createdAt), // Format the createdAt field
          };
        });

        setQuestions(userQuestions);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching user questions: ", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchUserQuestions();
  }, [userId]);

  return { questions, loading, error };
};

export default useUserQuestions;
